import { Box, Heading, Text } from '@chakra-ui/react'
import { Prose } from '@nikolovlazar/chakra-ui-prose'
import { NextSeo } from 'next-seo'
import React from 'react'
import ReactMarkdown from 'react-markdown'

type Props = {
  heading: string
  label?: string
  children?: React.ReactNode
  subheading?: string
}

export const Hero = (props: Props) => {
  return (
    <>
      <NextSeo title={props.heading} description={props.subheading} />
      <Box
        p='12'
        textAlign='center'
        bgColor='blue.900'
        color='white'
        backgroundPosition='left center'
        backgroundImage={"url('/img/nationHeroBackground.webp')"}
        backgroundSize='cover'
        position='relative'>
        {props.label && (
          <Text color='white' textTransform='uppercase'>
            {props.label}
          </Text>
        )}
        <Heading
          as='h1'
          color='white'
          textTransform='uppercase'
          fontSize={{ base: 'display3', lg: 'display2' }}>
          {props.heading}
        </Heading>
        {props.subheading && (
          <Heading as='div' fontSize='sm' maxW='3xl' mx='auto'>
            <Prose color='white'>
              <ReactMarkdown>{props.subheading}</ReactMarkdown>
            </Prose>
          </Heading>
        )}
        {props.children}
      </Box>
    </>
  )
}
